import * as R from 'ramda';
import { IProfile } from 'types/profile';

export const isTradingDeskUserOnly = (profile: IProfile | null): boolean => {
  if (profile === null) return false;
  const { roles, additionalRoles } = profile;

  return R.equals(roles, ['trading_desk_user']) && additionalRoles.length === 0;
};
